import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Table,
    notification,
    Modal,
    Button,
    Image,
    Pagination,
    Input,
    Carousel,
    Tooltip
} from "antd";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, EyeOutlined } from "@ant-design/icons";
import { baseUrl } from "../../config";
import { skeletonData } from "../../components/skeletons/Blog";
import moment from "moment";

const { Search } = Input;
const { confirm } = Modal;

// table code start
const columns = [
    {
        title: "#",
        dataIndex: "index",
        key: "index"
    },
    {
        title: "Name",
        dataIndex: "name",
        key: "name"
    },
    {
        title: "Type",
        dataIndex: "type",
        key: "type"
    },
    {
        title: "Purchased By",
        dataIndex: "ideaPurchasedBy",
        key: "ideaPurchasedBy"
    },
    {
        title: "Amount",
        dataIndex: "amount",
        key: "amount"
    },
    {
        title: "Purchased At",
        dataIndex: "createdAt",
        key: "createdAt"
    }
];

function TransactionHistoryList() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get('user');
    const ideaId = searchParams.get('idea');
    const [userList, setUserList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [modalVisible, setModalVisible] = useState(false);
    const [privacy, setPrivacy] = useState('');
    const [titleName, setTitleName] = useState();
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [imageType, setImageType] = useState('');

    useEffect(() => {
        getList()
    }, [searchTerm, currentPage, pageSize, userId, ideaId])

    async function getList() {
        try {
            setLoading(true);

            const params = {
                page: currentPage,
                items: pageSize,
            };

            if (userId) {
                params.userId = userId;
            }

            if (ideaId) {
                params.ideaId = ideaId;
            }

            // Check if search is not null or empty, then add it to params
            if (searchTerm && searchTerm.trim() !== '') {
                params.search = searchTerm;
            }

            // Make API call to submit form data
            const response = await axios.get(`${baseUrl}/api/admin/transaction-history`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
                params
            });
            if (response.data.success) {
                setUserList(response.data.result);
                setTotalUsers(response.data.pagination.count);
            } else {
                setUserList([])
            }
            // Handle success response from the API
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight' // You can adjust the placement as needed
            });
            // Handle error response from the API
        } finally {
            setLoading(false); // End loading
        }
    };

    async function handleDelete(id) {
        try {
            const response = await axios.delete(`${baseUrl}/api/blog/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            });
            if (response.status === 200) {
                getList();
                notification.success({
                    message: 'Success',
                    description: 'Faq deleted successfully!',
                    placement: 'topRight'
                });
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };


    const handleOk = () => {
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleSearch = (value) => {
        if (value.length >= 3 || value.length === 0) {
            setSearchTerm(value);
            setCurrentPage(1);
        }
    };

    const showImageModal = (images, type) => {
        setSelectedImages(images);
        setImageType(type);
        setImageModalVisible(true);
    };

    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Transaction History"
                            extra={
                                <>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "space-between" }}>
                                        <Search
                                            placeholder="Search by name, purchased by"
                                            onSearch={handleSearch}
                                            allowClear
                                            style={{ flex: 1, minWidth: "400px" }} // Makes search bar flexible
                                        />
                                        {/* <Link className="custom-btn" to="/blog-management/add">Add</Link> */}
                                    </div>
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={loading ? skeletonData : userList.map((user, index) => ({
                                        index: (currentPage - 1) * pageSize + index + 1,
                                        ideaPurchasedBy: (
                                            <Link to={`/users/${user?.createdBy?._id}`}>{user?.createdBy?.firstName} {user?.createdBy?.lastName ? user?.createdBy?.lastName : ''}</Link>
                                        ),
                                        type: user?.type === 'unlock_idea' ? 'Idea' : 'Storage',
                                        name: user?.name,
                                        amount: "€" + (user?.amount),
                                        createdAt: (
                                            <p>{moment(user.createdAt).format("MMMM DD, YYYY hh:mm A")}</p>
                                        )
                                    }))}
                                    pagination={false}
                                    className="ant-border-space"
                                />
                            </div>
                            {/* Keep pagination outside the scrollable div */}
                            <div className="pagination-container">
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={totalUsers}
                                    onChange={handlePageChange}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal
                title={`${titleName}`}
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <div className="author-info">
                    <div dangerouslySetInnerHTML={{ __html: privacy }} />
                </div>
            </Modal>
            <Modal
                title={imageType}
                visible={imageModalVisible}
                onCancel={() => setImageModalVisible(false)}
                footer={null}
                width={600}
            >
                <Carousel autoplay>
                    {selectedImages.map((file, i) => {
                        const fileUrl = file?.startsWith('http') ? file : `${baseUrl}/${file}`;
                        const isVideo = /\.(mp4|webm|ogg|MOV)$/i.test(file); // check file extension

                        return (
                            <div key={i} style={{ textAlign: 'center' }}>
                                {isVideo ? (
                                    <video
                                        controls
                                        style={{ maxHeight: '400px', maxWidth: '100%', objectFit: 'contain' }}
                                    >
                                        <source src={fileUrl} type="video/mp4" />
                                    </video>
                                ) : (
                                    <Image
                                        src={fileUrl}
                                        alt={`media-${i}`}
                                        style={{ maxHeight: '400px', maxWidth: '100%', objectFit: 'contain' }}
                                    />
                                )}
                            </div>
                        );
                    })}
                </Carousel>
            </Modal>


        </>
    );
}

export default TransactionHistoryList;
